import styled from "styled-components";
import { SubmitButton } from "../../ControleEnvios/styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 80%;
  color: #000;
  margin: 0 auto 10px;
`;

export const Center = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: ${props => props.space ? 'space-between' : 'center'};
`;

export const Text = styled.p`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;

export const ButtonGreen = styled(SubmitButton)`
  margin: 20px 0 0 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  div{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
